export const CATALOGUE_CONFIG_DOMAIN_TYPE = "catalogue_configuration";
export const CATALOGUE_CONFIG_DOMAIN_TYPE2 = "catalogue_sorting_options";
export const CATALOGUE_CONFIG_DOMAIN_TYPE3 = "tab_filters";
export const CATALOGUE_CONFIG_DOMAIN_NAME = "clientconfig";